import { mutationFor } from "@visioni/a3s-client-api/app";
import {
  createRoleAssignmentEndpoint,
  deleteRoleAssignmentEndpoint,
  inviteUserEndpoint,
  addCameraPermissionEndpoint,
  deleteCameraPermissionEndpoint,
  revokeUserAccessEndpoint,
} from "../client-messages/role-assignments";

export const createRoleAssignmentMutation = mutationFor(createRoleAssignmentEndpoint);

export const deleteRoleAssignmentMutation = mutationFor(deleteRoleAssignmentEndpoint);

export const inviteUserMutation = mutationFor(inviteUserEndpoint);

export const addCameraPermissionMutation = mutationFor(addCameraPermissionEndpoint);

export const deleteCameraPermissionMutation = mutationFor(deleteCameraPermissionEndpoint);

export const revokeUserAccessMutation = mutationFor(revokeUserAccessEndpoint);
